// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 856) return "content/plugin-pdf-plot-area/223c5f37735efc5d3d23fd9d7a9ee403.js";
	if (chunkId === 922) return "content/plugin-pdf-plot-area/2aeb197999c07e2eba3ae5990d26ee55.js";
	// return url for filenames based on template
	return undefined;
};